import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HelpdeskObject } from "./helpdesk.datamodel";
import { PipesModule } from '../shared/pipes/pipes.module';
import { CommonModule, KeyValuePipe } from '@angular/common';

/**
 * Component representing the helpdesk pop up.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ama-ng-helpdesk-message",
  standalone: true,
  imports: [
    PipesModule,
    KeyValuePipe,
    CommonModule
  ],
  templateUrl: "./helpdesk.component.html"
})
export class HelpdeskComponent {

  constructor(public activeModal: NgbActiveModal, readonly helpdeskInfo: HelpdeskObject) {
  }

}
